import React from 'react';

import './styles/footer.css';

function Footer() {
  return (
    <>
      <footer className="App-footer">
        <p className="App-footer-text">Copyright©2024 <a href="https://ch3nyang.top/">ch3nyang</a>. All rights reserved.</p>
        <p className="App-footer-text">Open source on <a href="https://github.com/WCY-dt/mindclip">GitHub</a>.</p>
      </footer>
    </>
  )
}

export default Footer;
